(function(api) {
	api.OsKontoNaziv = OsKontoNaziv;
	api.GetNovaSoba = GetNovaSoba;
	api.GetNovaZgrada = GetNovaZgrada;
	api.InvenSObrisi = InvenSObrisi;
	api.InvenSPronadeno = InvenSPronadeno;
	api.InvenSZaRashod = InvenSZaRashod;
	api.InvenSBrojPronadenihZaFilter = InvenSBrojPronadenihZaFilter;
	api.InvenSPronadenoFilter = InvenSPronadenoFilter;
	api.SredByBarkod = SredByBarkod;
	api.SredByInvBroj = SredByInvBroj;
	api.OsZaduziById = OsZaduziById;
	api.SredStById = SredStById;
	api.InvensPostoji = InvensPostoji;
	api.SredById = SredById;
	api.OsobaBySred = OsobaBySred;
	api.SobaByBarkod = SobaByBarkod;
	api.IKnjigaNabDefault = IKnjigaNabDefault;
	api.IRekapKnjDefault = IRekapKnjDefault;
	api.IAktDefault = IAktDefault;
	api.ZgradaById = ZgradaById;
	api.SobaById = SobaById;
	api.LokacijaById = LokacijaById;	
	api.LokacijaPostoji = LokacijaPostoji;
	api.GetOsZaduziFields = GetOsZaduziFields;
	api.GetSredStFields = GetSredStFields;
	api.TipPromById = TipPromById;	
	api.GetNoviBrojDok = GetNoviBrojDok;
	api.LokacijaObrisi = LokacijaObrisi;

    function GetSredStFields() {
        return $.dsDirectCall({ 
			method: "GetSredStFields"
        });
    }

    function GetOsZaduziFields() {
        return $.dsDirectCall({ 
			method: "GetOsZaduziFields" 
        });
    }

	function LokacijaPostoji(lokacija, zgrada, soba){
		return $.dsDirectCallSync({
			method: "LokacijaPostoji",
			params: [ lokacija, zgrada, soba ]
		});
	}

	function OsKontoNaziv(osKonto){ //vraća cijeli Konto
		return $.dsDirectCall({
			method: "OsKontoNaziv",
			params: [ osKonto ]
		});
	}
	
	function GetNovaSoba(lokacija, zgrada){
		return $.dsDirectCall({
			method: "GetNovaSoba",
			params: [ lokacija, zgrada ]
		});
	}
	
	function GetNovaZgrada(lokacija){
		return $.dsDirectCall({
			method: "GetNovaZgrada",
			params: [ lokacija ]
		});
	}
	
	function InvenSObrisi(invens){
		return $.dsDirectCall({
			method: "InvenSObrisi",
			params: [ invens ]
		});
	}
	
	function InvenSPronadeno(invens){
		return $.dsDirectCall({
			method: "InvenSPronadeno",
			params: [ invens ]
		});
	}
	
	function InvenSZaRashod(invens){
		return $.dsDirectCall({
			method: "InvenSZaRashod",
			params: [ invens ]
		});
	}
	
	function InvenSBrojPronadenihZaFilter(invens, osoba){
		return $.dsDirectCall({
			method: "InvenSBrojPronadenihZaFilter",
			params: [ invens, osoba ]
		});
	}
	
	function InvenSPronadenoFilter(invens, osoba){
		return $.dsDirectCall({
			method: "InvenSPronadenoFilter",
			params: [ invens, osoba ]
		});
	}
	
	function SredByBarkod(barkod){
		return $.dsDirectCall({
			method: "SredByBarkod",
			params: [ barkod ]
		});
	}
	
	function SredByInvBroj(invBroj){
		return $.dsDirectCall({
			method: "SredByInvBroj",
			params: [ invBroj ]
		});
	}
	
	function OsZaduziById(osZaduzi, lokacija, zgrada, soba){
		return $.dsDirectCall({
			method: "OsZaduziById",
			params: [ osZaduzi, lokacija, zgrada, soba]
		});
	}
	
	function SredStById(zSredst){
		return $.dsDirectCall({
			method: "SredStById",
			params: [ zSredst ]
		});
	}
	
	function InvensPostoji(inven, sred, lokacija, zgrada, soba){
		return $.dsDirectCall({
			method: "InvensPostoji",
			params: [ inven, sred, lokacija, zgrada, soba ]
		});
	}
	
	function SredById(sred){
		return $.dsDirectCall({
			method: "SredById",
			params: [ sred ]
		});
	}
	
	function OsobaBySred(sred){
		return $.dsDirectCall({
			method: "OsobaBySred",
			params: [ sred ]
		});
	}
	
	function SobaByBarkod(barkod){
		return $.dsDirectCall({
			method: "SobaByBarkod",
			params: [ barkod ]
		});
	}
	
	function IKnjigaNabDefault(){
		return $.dsDirectCall({
			method: "IKnjigaNabDefault"
		});
	}
	
	function IRekapKnjDefault(){
		return $.dsDirectCall({
			method: "IRekapKnjDefault"
		});
	}
	
	function IAktDefault(){
		return $.dsDirectCall({
			method: "IAktDefault"
		});
	}
	
	function LokacijaById(lokacija){
		return $.dsDirectCall({
			method: "LokacijaById",
			params: [ lokacija ]
		});
	}

	function ZgradaById(lokacija, zgrada){
		return $.dsDirectCall({
			method: "ZgradaById",
			params: [ lokacija, zgrada ]
		});
	}
	
	function SobaById(lokacija, zgrada, soba){
		return $.dsDirectCall({
			method: "SobaById",
			params: [ lokacija, zgrada, soba ]
		});
	}

	function TipPromById(tipprom){
		return $.dsDirectCall({
			method: "TipPromById",
			params: [ tipprom ]
		});
	}	
	
	function GetNoviBrojDok(dok){
		return $.dsDirectCall({
			method: "GetNoviBrojDok",
			params: [ dok ]
		});
	}
	
	function LokacijaObrisi(lokacija){
		return $.dsDirectCall({
			method: "LokacijaObrisi",
			params: [ lokacija ]
		});
	}

} (konto.os.api = {}));